module.exports = __webpack_public_path__ + "static/media/Mobile.29d1a393.webp";